import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f8ceb008")
const _hoisted_1 = { class: "toolbar__left" }
const _hoisted_2 = { class: "p-d-flex p-jc-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-3" })
], -1)
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-road p-mr-3" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-road p-mr-3" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_10 = { class: "p-d-flex p-jc-between" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-3" })
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    class: "p-mb-3",
    header: "Filters",
    toggleable: true,
    collapsed: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t(`user_autocomplete.label`)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.advFilters.user,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters.user = $event)),
              suggestions: _ctx.filteredDrivers,
              onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchUser($event))),
              field: _ctx.getField,
              completeOnFocus: "",
              dropdown: "",
              onItemSelect: _ctx.onSelectedUser
            }, {
              item: _withCtx(({item}) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(item.name) + " " + _toDisplayString(item.surname), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "suggestions", "field", "onItemSelect"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_FloatLabel, { label: "Search Work Request" }, {
          default: _withCtx(() => [
            _createVNode(_component_AutoComplete, {
              dropdown: "",
              completeOnFocus: "",
              modelValue: _ctx.advFilters.shift,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.advFilters.shift = $event)),
              suggestions: _ctx.filteredWrs,
              field: _ctx.selectedLabel,
              onComplete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchWRS($event))),
              onItemSelect: _ctx.onSelectedShift
            }, {
              chip: _withCtx(({item}) => [
                _createElementVNode("div", {
                  title: _ctx.getTitle(item)
                }, [
                  _hoisted_5,
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "#" + _toDisplayString(item.id), 1),
                    _hoisted_6
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.code), 1)
                ], 8, _hoisted_4)
              ]),
              item: _withCtx(({item}) => [
                _createElementVNode("div", {
                  title: _ctx.getTitle(item)
                }, [
                  _hoisted_8,
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "#" + _toDisplayString(item.id), 1),
                    _hoisted_9
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.code), 1)
                ], 8, _hoisted_7)
              ]),
              _: 1
            }, 8, ["modelValue", "suggestions", "field", "onItemSelect"])
          ]),
          _: 1
        }),
        (_ctx.canSee)
          ? (_openBlock(), _createBlock(_component_FloatLabel, {
              key: 0,
              label: "Broker"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AutoComplete, {
                  dropdown: "",
                  completeOnFocus: "",
                  modelValue: _ctx.advFilters.broker,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.advFilters.broker = $event)),
                  suggestions: _ctx.filteredBrokers,
                  field: "business_name",
                  minLength: 2,
                  label: "Broker",
                  onItemSelect: _ctx.onBrokerSelected,
                  onComplete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchBroker($event)))
                }, {
                  item: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(item.business_name), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions", "onItemSelect"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_FloatLabel, { label: "Search by Status" }, {
            default: _withCtx(() => [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.advFilters.status,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.advFilters.status = $event)),
                options: _ctx.ticketStatuses,
                optionLabel: "label",
                onChange: _ctx.onSelectedStatus,
                placeholder: "Select Status",
                optionValue: "value"
              }, null, 8, ["modelValue", "options", "onChange"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}